import Vue from 'vue'
import Router from 'vue-router'
import homePage from '@/components/happyBirthday/homePage'
import blessing from '@/components/happyBirthday/blessing'
import signUp from '@/components/happyBirthday/signUp'
import nbOL from '@/components/nbOL/homePage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'nbOL',
      component: nbOL,
      meta: {
        title: '宁波OL改造计划'
      }
    },
    {
      path: 'home/',
      name: 'homePage',
      component: homePage,
      meta: {
        title: '生日会'
      }
    },
    {
      path: '/blessing',
      name: 'blessing',
      component: blessing,
      meta: {
        title: '为朋友祝福'
      }
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: signUp,
      meta: {
        title: '报名页面'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js